import { createApi } from '@reduxjs/toolkit/query/react';
import { createApiConfig } from '../../createApiConfig';

export const uMUsersApi = createApi({
  reducerPath: 'uMUsersApi',
  ...createApiConfig(process.env.REACT_APP_API_BASE_URL),
  tagTypes: ['Users'],
  endpoints: (builder) => ({
    
    listUsers: builder.query({
      query: (params) => ({
        url: `users/`,
        params,
      }),
      providesTags: ['Users'],
    }),
    createUser: builder.mutation({
      query: (data) => ({
        url: `users/`,
        method: 'POST',
        body: data,
      }),
      invalidatesTags: ['Users'],
    }),
    updateUser: builder.mutation({
      query: ({ id, data }) => ({
        url: `users/${id}/`,
        method: 'PATCH',
        body: data,
      }),
      invalidatesTags: ['Users'],
    }),
    deleteUser: builder.mutation({
      query: (id) => ({
        url: `users/${id}/`,
        method: 'DELETE',
      }),
      invalidatesTags: ['Users'],
    }),
    activateUser: builder.mutation({
      query: (id) => ({
        url: `users/${id}/`,
        method: 'PATCH',
        body: { is_active: true },
      }),
      invalidatesTags: ['Users'],
    }),

    
  }),
});

export const {
  useListUsersQuery,
  useCreateUserMutation,
  useUpdateUserMutation,
  useDeleteUserMutation,
  useActivateUserMutation,
} = uMUsersApi;
